var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yj-paper-preview" },
    [
      _c("page-header", {
        attrs: { title: "", paths: ["试卷管理", "切录题", "试卷预览"] },
      }),
      _c("p", { staticClass: "paper-title bold" }, [
        _vm._v(_vm._s(_vm.exam.examName) + "_" + _vm._s(_vm.exam.subjectName)),
      ]),
      _c(
        "ul",
        { staticClass: "big-list" },
        _vm._l(_vm.list, function (big, index) {
          return _c("li", { key: "big" + index, staticClass: "big-li" }, [
            _c("p", { staticClass: "big-title bold" }, [
              _vm._v(_vm._s(big.bigNum) + "、" + _vm._s(big.pattern.name)),
            ]),
            _c(
              "ul",
              { staticClass: "small-list" },
              _vm._l(big.items, function (small, sIndex) {
                return _c(
                  "li",
                  { key: index + "small" + sIndex, staticClass: "small-li" },
                  [
                    _c("div", { staticClass: "ques-content" }, [
                      _c("span", { staticStyle: { "font-weight": "500" } }, [
                        _vm._v(_vm._s(small.raw.smallNum) + ". "),
                      ]),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.contentHtml(small.stem.contentHtml)
                          ),
                        },
                      }),
                    ]),
                    small.answer
                      ? _c("div", { staticClass: "ques-content" }, [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "500" } },
                            [_vm._v("答案：")]
                          ),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.contentHtml(small.answer.contentHtml)
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                    small.explanation
                      ? _c("div", { staticClass: "ques-content" }, [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "500" } },
                            [_vm._v("解析：")]
                          ),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.contentHtml(small.explanation.contentHtml)
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                    small.points
                      ? _c(
                          "div",
                          { staticClass: "ques-content" },
                          [
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "500" } },
                              [_vm._v("考察知识点：")]
                            ),
                            small.points.length
                              ? _vm._l(small.points, function (point, index) {
                                  return _c("span", { key: point }, [
                                    _vm._v(" " + _vm._s(point.name)),
                                    _c(
                                      "i",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              index < small.points.length - 1,
                                            expression:
                                              "index < small.points.length - 1",
                                          },
                                        ],
                                      },
                                      [_vm._v("，")]
                                    ),
                                  ])
                                })
                              : _c(
                                  "span",
                                  { staticStyle: { color: "#ff4c3b" } },
                                  [_vm._v("未设置")]
                                ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }